import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { Phone } from 'lucide-react';

const FAQSection = () => {
  const faqs = [
    {
      question: 'What areas do you serve?',
      answer:
        'We proudly serve businesses throughout the South Shore Massachusetts region, including Quincy, Braintree, Weymouth, Hingham, Plymouth, Marshfield, Norwell, Hanover, and surrounding communities. We offer both on-site and remote IT support services to ensure we can assist you wherever you need us.',
    },
    {
      question: 'Do you offer 24/7 support?',
      answer:
        "Yes! We provide 24/7 emergency support for critical IT issues like server outages, network failures, and security breaches. Our standard business hours are Monday-Friday 8AM-6PM and Saturday 9AM-2PM, but we're always available when you need us most. Emergency support is included in all monthly support plans.",
    },
    {
      question: 'What size businesses do you work with?',
      answer:
        "We specialize in small to medium-sized businesses with 50 or fewer users. Whether you're a startup with 5 employees or an established company with 50, we have the expertise and solutions to meet your IT needs. Our pricing scales with your business, so you only pay for what you need.",
    },
    {
      question: 'How quickly can you respond to IT emergencies?',
      answer:
        'For critical emergencies (server down, network outage, security breach), we aim to respond within 1 hour with remote support and can be on-site within 2-4 hours if needed. For standard support requests, we typically respond within 2-4 hours during business hours. Our goal is to minimize downtime and keep your business running smoothly.',
    },
    {
      question: 'Do you offer customized IT solutions?',
      answer:
        "Absolutely! Every business is unique, and we tailor our IT services to match your specific needs, budget, and goals. We start with a free IT assessment to understand your current setup, identify pain points, and recommend solutions. We'll work with you to create a custom IT strategy that supports your business growth.",
    },
    {
      question: 'What is your pricing structure?',
      answer:
        'Our monthly support plans start at $250 per user, which includes 24/7 support, network monitoring, security updates, and regular maintenance. We also offer hourly rates for one-time projects and special pricing for non-profits. Contact us for a free consultation, and we\'ll provide a customized quote based on your specific IT needs.',
    },
    {
      question: 'Do you work with Non-Profit organizations?',
      answer:
        "Yes! We're committed to supporting Non-Profit organizations with cost-effective IT solutions tailored to fit your budget. We offer discounted rates for qualifying non-profits and can help you take advantage of programs like Microsoft 365 for Nonprofits. We understand the financial constraints Non-Profits face and provide enterprise-grade support at sustainable costs.",
    },
    {
      question: 'What certifications do your technicians have?',
      answer:
        'Our team holds industry-leading certifications including CompTIA A+, CompTIA Network+, CompTIA Security+, Microsoft 365 Fundamentals (MS-900), Microsoft Endpoint Administrator (MD-102), and Cisco CCNA. We continuously invest in training to stay current with the latest technologies and best practices.',
    },
    {
      question: 'Can you help migrate our business to Office 365?',
      answer:
        'Absolutely! Office 365 migration is one of our specialties. We handle the entire process including planning, email migration, data transfer, user training, and ongoing support. We ensure zero data loss and minimal disruption to your business operations. Most migrations can be completed within 1-2 weeks depending on your organization\'s size.',
    },
    {
      question: 'How do I get started with your services?',
      answer:
        "Getting started is easy! Simply call us at 774-644-7101 or fill out our contact form. We'll schedule a free consultation to discuss your IT needs, assess your current setup, and provide a customized proposal. There's no obligation, and we're happy to answer any questions you have about how we can help your business.",
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-cyan-500 uppercase tracking-wide mb-2">
            FAQ
          </p>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">Got questions? We've got answers.</p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="border border-gray-200 rounded-lg px-6 bg-gray-50 hover:bg-gray-100 transition-colors"
            >
              <AccordionTrigger className="text-left font-semibold text-gray-900 hover:text-blue-600">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="text-center mt-12 p-6 bg-gray-50 rounded-xl border border-gray-200">
          <p className="text-lg font-semibold text-gray-900 mb-3">Still have questions?</p>
          <a
            href="tel:+17746447101"
            className="inline-flex items-center text-blue-600 hover:text-blue-700 font-semibold text-lg"
          >
            <Phone className="w-5 h-5 mr-2" />
            Call Us: 774-644-7101
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;